export class Beneficiary {
  lastName: string;
  firstName: string;
  contact: string;
  beneficiaryId: number;
  contactId:number;
}
